import { WindowLocation } from '@reach/router';
import { createBrowserHistory } from 'history';

const create = typeof window === 'undefined' ? null : createBrowserHistory();

export function changePage(page: string) {
  const currentUrlParams = new URLSearchParams(window.location.search);
  currentUrlParams.set('page', page);
  currentUrlParams.delete('subscriptionId');
  create?.push(`${window.location.pathname}?${currentUrlParams.toString()}`);
}

export function setHistoryParam(name: string, id: string, replace?: boolean) {
  const currentUrlParams = new URLSearchParams(window.location.search);
  currentUrlParams.set(name, id);
  if (replace) {
    create?.replace(`${window.location.pathname}?${currentUrlParams.toString()}`);
  } else {
    create?.push(`${window.location.pathname}?${currentUrlParams.toString()}`);
  }
}

export function removeHistoryParam(name: string) {
  const currentUrlParams = new URLSearchParams(window.location.search);
  currentUrlParams.delete(name);
  create?.push(`${window.location.pathname}?${currentUrlParams.toString()}`);
}

// TODO Can we replace this return with the return of getURLParameters below?
export function getParams() {
  if (typeof window === 'undefined') {
    return {};
  }
  const searchParams = new URLSearchParams(window.location.search);

  return {
    page: searchParams.get('page') || '',
    subscriptionId: searchParams.get('subscriptionId') || '',
    screeningId: searchParams.get('screeningId') || '',
    consultation: searchParams.get('consultation') || false,
    ppcCheckout: searchParams.get('ppcCheckout') || false,
    consultationId: searchParams.get('consultationId') || '',
    specialist: searchParams.get('specialist') || null,
    selected: searchParams.get('selected') || null,
    panel: searchParams.get('panel') || '',
    reportTab: searchParams.get('reportTab') || null,
    activateTest: searchParams.get('activateTest') || false,
    setName: searchParams.get('setName') || false,
    storedRefSource: searchParams.get('utm_source') || '',
    storedRefMedium: searchParams.get('utm_medium') || '',
    step: searchParams.get('step') || 0,
    unlocked: searchParams.get('unlocked') || false,
    kitVariation: searchParams.get('kitVariation') || '',
    treatmentId: searchParams.get('treatmentId') || '',
    banner: searchParams.get('banner') || '',
    screeningType: searchParams.get('screeningType') || ''
  };
}

export function getURLParameters(location: WindowLocation) {
  if (!location) {
    return {};
  }
  const searchParams = new URLSearchParams(location.search);

  const paramsObj: { [key: string]: string } = {};

  searchParams.forEach((value, key) => {
    paramsObj[key] = value;
  });

  return paramsObj;
}
